module.exports = __webpack_public_path__ + "static/media/commit_image.caab5ff1.png";